import { Stack, Typography } from '@mui/material'
import {
  StudyTimepointContainerRequirementSchema,
  TimepointContainerSubmissionExamMetadataResponse,
} from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import { formatExamAcquisitionDate } from './formatExamAcquisitionDate'

export default function UpdateSubmissionStatusExams({
  container_requirement,
  exam,
}: {
  container_requirement: StudyTimepointContainerRequirementSchema
  exam: TimepointContainerSubmissionExamMetadataResponse
}) {
  return (
    <Stack
      direction="row"
      spacing={SPACING.examDetailsSpacing}
      alignItems="center"
      justifyContent="space-between"
      paddingX={SPACING.examDetailsSpacing}
      paddingY={SPACING.minSpacing}
    >
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Modality
        </Typography>
        <Typography variant="body2">{container_requirement.name}</Typography>
      </Stack>
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Study description
        </Typography>
        <Typography variant="body2">{exam.study_description}</Typography>
      </Stack>
      <Stack spacing={SPACING.examDetailsTypographySpacing}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Date
        </Typography>
        <Typography variant="body2">{formatExamAcquisitionDate(exam.acquisition_date)}</Typography>
      </Stack>
    </Stack>
  )
}
